var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("catalog-select", {
        ref: "catalog_select",
        attrs: {
          "catalog-name": "гражданство",
          "is-disabled": _vm.isDisabled,
          state: _vm.state,
          "initial-value": _vm.value,
          "get-item-by-id": _vm.getCitizenship,
          "get-list": _vm.getItems,
          "can-create-catalog": _vm.canEditCitizenship()
        },
        on: {
          onSelect: function($event) {
            return _vm.$emit("onSelect", $event)
          },
          "open-modal": function($event) {
            _vm.isModalVisible = true
          }
        }
      }),
      _vm._v(" "),
      _vm.isModalVisible
        ? _c("citizenship", {
            attrs: { "create-id": 0 },
            on: {
              "modal-closed": function($event) {
                _vm.isModalVisible = false
              },
              refresh: _vm.onCatalogItemCreated
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cb943496", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb943496","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/Citizenships/CitizenshipSelect.vue
// module id = null
// module chunks = 